import { dsClass } from '../../common/constants/dsClasses.js';
import { postalCodeMsg, t } from '../../common/i18n/index.js';
import { POSTAL_CODE_PARTIAL_REGEX, POSTAL_CODE_REGEX } from '../../common/utils/validationUtils.js';
import { Icon } from '../Icon/Icon.js';
import { Input } from '../Input/Input.js';

import './PostalCodeInput.scss';

interface ValidationErrorsMap {
  [s: string]: string;
}

export interface PostalCodeInputProps {
  postalCode?: string;
  disabled?: boolean;
  setPostalCode: (postalCode: string) => void;
  validationErrors?: ValidationErrorsMap;
  setValidationErrors?: (errors?: ValidationErrorsMap) => void;
  className?: string;
}

// By default, input type=number allows these characters as well. They do not make
// sense in the context of entering a postal code.
export const DISALLOWED_CHARACTERS = ['e', 'E', '+', '-', '.', ','];

/**
 * TODO consider syncing this component with src/common/react-hook-form/fields/PostalCode.tsx
 * so that there would be only one implementation for PostalCode
 */
export const PostalCodeInput = (props: PostalCodeInputProps) => {
  const { postalCode, setPostalCode, validationErrors, setValidationErrors, className } = props;
  const isValidPostalCode = postalCode ? POSTAL_CODE_REGEX.test(postalCode) : false;

  return (
    <div className={className ?? `${dsClass.POSITION_RELATIVE} of-postal-code__wrapper`}>
      <Input
        data-testid="postal-code-input"
        error={validationErrors?.postalCode}
        placeholder={t.RUAW(postalCodeMsg)}
        label={t.RUAW(postalCodeMsg)}
        name="postalCode"
        disabled={props.disabled}
        onKeyDown={event => {
          if (DISALLOWED_CHARACTERS.includes(event.key)) {
            event.preventDefault();
          }
        }}
        onChange={event => {
          if (POSTAL_CODE_PARTIAL_REGEX.test(event?.currentTarget?.value)) {
            setValidationErrors?.(undefined);
            setPostalCode(event.currentTarget.value);
          }
        }}
        inputMode="numeric"
        type="number"
        min={0}
        max={99999}
        value={postalCode}
      />
      {isValidPostalCode && (
        <span className={`of-postal-code__check-icon ${dsClass.POSITION_ABSOLUTE} ${dsClass.BACKGROUND_COLOR_WHITE}`}>
          <Icon icon="check" color="green-600" />
        </span>
      )}
    </div>
  );
};
